import React from 'react'
import { withUserPermissions } from '../containers/App'
import { castArray, every, includes } from 'lodash/fp'

const decorate = withUserPermissions

const withPermissions = (WrappedComponent) => {
  class WithPermissions extends React.Component {
    hasPermissions = (permissions) => {
      const checkPermission = (p) => includes(p, this.props.userPermissions)
      return every(checkPermission, castArray(permissions))
    }

    hasRoles = (roles) => {
      const checkPermission = (r) => includes(r, this.props.userRoles)
      return every(checkPermission, castArray(roles))
    }

    isHigherLevel = (level) => {
      const checkPermission = (lv) => this.props.userLevel > lv
      return every(checkPermission, castArray(level))
    }

    render() {
      return (
        <WrappedComponent
          hasPermissions={this.hasPermissions}
          hasRoles={this.hasRoles}
          isHigherLevel={this.isHigherLevel}
          {...this.props}
        />
      )
    }
  }
  return decorate(WithPermissions)
}

export default withPermissions
